import React from 'react';

export const UsersList = React.lazy(() => import('./UsersList'));
export const UserDetails = React.lazy(() => import('./UserDetails'));
export const UserForm = React.lazy(() => import('./UserForm'));
